import { EyeIcon, EyeOffIcon } from "lucide-react";
import React, { useState } from "react";

import { cn } from "../lib/utils";
import { Input } from "./ui/input";

type PasswordInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(({ className, ...inputProps }, ref) => {
	const [visible, setVisible] = useState(false);

	return (
		<div className="relative w-full">
			<Input {...inputProps} ref={ref} type={visible ? "text" : "password"} className={cn("pe-9", className)} />
			<button
				type="button"
				onClick={() => setVisible((prev) => !prev)}
				className="absolute inset-y-0 end-0 flex h-full w-9 items-center justify-center rounded-e-md text-muted-foreground/80 outline-none transition-[color,box-shadow] hover:text-foreground focus:z-10 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
				aria-label={visible ? "Hide password" : "Show password"}
				aria-pressed={visible}
			>
				{visible ? <EyeOffIcon aria-hidden="true" size={16} /> : <EyeIcon aria-hidden="true" size={16} />}
			</button>
		</div>
	);
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
